import { usePropertyProvider } from '../usePropertyProvider'
import { usePublication } from '../usePublication'

/**
 * DataLayer object for the facility-wide plan index (`/:property/plans`).
 *
 * Unlike `usePlanDataLayerObject` (the room-scoped `/:property/:room/plans`
 * page), this page has NO `room` route param, so we build a property-level
 * event from `usePropertyProvider` alone — mirroring `useRoomDataLayerObject`
 * (the room-list page). Reusing `usePlanDataLayerObject` here would emit a
 * `null` event because it depends on `useRoomApi({ property, room })`.
 */
export const usePlanListDataLayerObject = () => {
  const { publications, id } = usePropertyProvider()
  const publication = usePublication('ja', publications)

  if (!publication) {
    return null
  }

  return {
    event: 'view_item_list',
    ecommerce: {
      items: [
        {
          item_id: id,
          item_name: publication?.name,
          booking_type: 'hotel',
        },
      ],
    },
  }
}
